import { createContext, useContext, useState, ReactNode } from 'react';
import { CustomContentItem } from '../api/customContentApi';

interface CustomContentContextValue {
  selectedContent: CustomContentItem | null;
  setSelectedContent: (content: CustomContentItem | null) => void;
}

const CustomContentContext = createContext<CustomContentContextValue | undefined>(undefined);

interface CustomContentProviderProps {
  children: ReactNode;
}

export function CustomContentProvider({ children }: CustomContentProviderProps) {
  const [selectedContent, setSelectedContent] = useState<CustomContentItem | null>(null);

  const value: CustomContentContextValue = {
    selectedContent,
    setSelectedContent,
  };

  return <CustomContentContext.Provider value={value}>{children}</CustomContentContext.Provider>;
}

export function useCustomContentContext(): CustomContentContextValue {
  const context = useContext(CustomContentContext);
  if (context === undefined) {
    throw new Error('useCustomContentContext must be used within a CustomContentProvider');
  }
  return context;
}

